import { cloneDeep } from "lodash";
import { allAgreementStatusOptions, allBudgetTypesOptions, allClassificationTypesOptions, allDataSourcesOptions, allPeriodicitiesOptions, allReportNamesOptions, allReportTypesOptions } from "../../common/baseOptions";
import { Template } from "../../common/types/Template";
import { LoanStatusFilterOptions } from "./options/LoanStatusFilterOptions";
import { LoanStatusFilterSettings } from "./settings/LoanStatusFilterSettings";

// Нужна как временная затычка (При созданий нового берутся пустые настройки)
const tempSettings: LoanStatusFilterSettings = {
    // Base:
    reportName: 'LOAN-STATUS',
    reportType: 'REGULATED',
    classificationType: 'MIXED',
    dataSource: 'LOADER',
    periodicity: 'DAY',
    // Custom:
    date: null,
    budgetType: 2,
    region: null,
    creditor: null,
    administrator: null,
    contractor: null,
    loanPurpose: null,
    agreementStatus: null,
    // measureUnit: 'THOUSAND',
    // roundUpTo: null,
    // incomes: [],
    // expenses: []
}

export const loanStatusBaseTemplate: Template = {
    id: null,
    name: 'Информация о состоянии долга области по бюджетным кредитам',
    excelName: null,
    description: null,
    category: '95',
    regions: [],
    userId: '',
    filterSettings: tempSettings
}

export const loanStatusFilterOptions: LoanStatusFilterOptions = {
    // Base:
    key: 'LOAN-STATUS',
    reportNames: cloneDeep(allReportNamesOptions),
    reportTypes: cloneDeep(allReportTypesOptions),
    classificationTypes: cloneDeep(allClassificationTypesOptions),
    dataSources: cloneDeep(allDataSourcesOptions),
    periodicities: cloneDeep(allPeriodicitiesOptions),
    // Custom:
    budgetTypes: cloneDeep(allBudgetTypesOptions).filter(it => it.value === 1 || it.value === 2),
    regions: [], // Загружается с бэка
    creditors: [], // Загружается с бэка
    administrators: [], // Загружается с бэка
    contractors: [], // Загружается с бэка
    loanPurposes: [], // Загружается с бэка
    agreementStatuses: cloneDeep(allAgreementStatusOptions), // Загружается с бэка
}
